module.exports = __webpack_public_path__ + "img/21.036efcc3.gif";